import { useState, Fragment, useContext } from 'react';
import { history } from 'umi';
import { Row, Col } from 'antd';
import { Form, Typography, Button } from 'iglooform';
import { images } from '@/assets/images';
import { useIntl } from 'react-intl';
import throttle from 'lodash/throttle';
import { BackButton } from '@/components/back-button/back-button';
import { HeaderTitle } from '@/components/header-title/header-title';
import { resetPassword } from '../service';
import Context from '@/utils/context';
import './index.less';

const ForgetPasswordPage = () => {
  const form = Form.useForm();
  const { formatMessage } = useIntl();
  const { isPc } = useContext(Context);
  const [showFeedback, setFeedback] = useState<boolean>(false);

  const handleResetPassword = throttle(
    async (): Promise<void> => {
      try {
        const values = await form.validateFields();
        resetPassword({ email: values.email.trim() }).then((res) => {
          res && res.status === 'ok' && setFeedback(true);
        });
      } catch (error) {
        console.log(error);
      }
    },
    1000,
    { leading: true, trailing: false },
  );

  if (showFeedback) {
    return (
      <Row className="check-email-layout">
        <Col span={isPc ? 12 : 24} className="check-email-col">
          <img src={images.email_icon} alt="" className="image" />
          <Typography level="h2" className="title">
            {formatMessage({ id: 'Check Your Email' })}
          </Typography>
          <Typography level="body1" className="content">
            {formatMessage({
              id: 'We have sent a password recover instructions to your email',
            })}
          </Typography>
          <Button
            type="default"
            className="button"
            onClick={() => history.replace('/login')}
          >
            {formatMessage({ id: 'Got it!' })}
          </Button>
        </Col>
      </Row>
    );
  }

  return (
    <Fragment>
      <BackButton handleClick={() => history.push('/login')} />
      <Row style={isPc ? { marginTop: '40px' } : { marginTop: '24px' }}>
        <Col
          span={isPc ? 12 : 24}
          style={{ maxWidth: '538px', margin: '0 auto' }}
        >
          <HeaderTitle
            title={formatMessage({ id: 'Forgot Password' })}
            subTitle={formatMessage({
              id: 'To reset your password, please enter your email address. We will send the password reset emali to you',
            })}
          />
          <div className="form-container">
            <Form
              form={form}
              config={{
                type: 'Login',
                elements: [
                  {
                    type: 'Input',
                    label: formatMessage({ id: 'Email' }),
                    name: 'email',
                    fullRow: true,
                    rules: [
                      {
                        validator: (_: any, value: string) => {
                          const regExp =
                            /^(\s+|[a-zA-Z0-9._-])+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+([a-zA-Z]|\s+)$/;
                          if (!!value && !regExp.test(value)) {
                            return Promise.reject(
                              new Error(
                                formatMessage({
                                  id: 'Email format is not correct!',
                                }),
                              ),
                            );
                          } else {
                            return Promise.resolve();
                          }
                        },
                      },
                    ],
                  },
                ],
              }}
              onSubmit={handleResetPassword}
              locales={{
                submitText: formatMessage({
                  id: 'Send Reset Email',
                  defaultMessage: 'Send Reset Email',
                }),
                validateMessages: {
                  required:
                    '${label} ' +
                    formatMessage({
                      id: 'is required',
                    }),
                },
              }}
            />
          </div>
        </Col>
      </Row>
    </Fragment>
  );
};

export default ForgetPasswordPage;
